<template>
    <site-img
        type="bgImg"
        class="md-tc-sp-cta standard"
        :src="type === 'img' ? usePicture : ''"
        :style="{
            backgroundColor: type === 'color' ? backgroundColor : '',
            paddingTop,
            marginBottom
        }"
    >
        <div
            ref="content"
            class="content-box"
            :class="{
                'mg-container': !fullColumn
            }"
            :style="{
                minHeight: minHeight
            }"
        >
            <div v-if="title" class="mg-title" v-html="formatFontSize(title, '--mg-title-size')"></div>
            <div class="button-box">
                <a
                    class="button left"
                    :href="leftButtonOption.type === 'callback' ? null : leftButtonOption.link"
                    @click="showRegisterPop(leftButtonOption)"
                    rel="noopener noreferrer"
                    :target="leftButtonOption.target || '_blank'"
                    :style="{
                        backgroundColor: leftButtonOption.backgroundColor,
                        borderColor: leftButtonOption.borderColor
                    }"
                >
                    <i class="iconfont icon-show"></i>
                    <div class="text" v-html="leftButtonOption.text"></div>
                </a>
                <a
                    class="button right"
                    :href="rightButtonOption.type === 'callback'? null : rightButtonOption.link"
                    @click="showRegisterPop(rightButtonOption)"
                    rel="noopener noreferrer"
                    :target="rightButtonOption.target || '_blank'"
                    :style="{
                        backgroundColor: rightButtonOption.backgroundColor,
                        borderColor: rightButtonOption.borderColor
                    }"
                >
                    <i class="iconfont icon-sell"></i>
                    <div class="text" v-html="rightButtonOption.text"></div>
                </a>
            </div>
        </div>
    </site-img>
</template>

<script>
import common from '../index';
export default {
    mixins: [common]
};
</script>
<style lang="scss">
@import '../../../theme/mixin.scss';
@import '../../../theme/media.scss';

.md-tc-sp-cta.standard {
    width: 100%;
    .content-box {
        display: flex;
        flex-direction: column;
        .mg-title {
            flex: none;
            width: 100%;
            padding-bottom: 0;
        }
        .button-box {
            margin-top: 20px;
            flex: 1;
            display: flex;
            justify-content: space-between;
            .button {
                width: calc(50% - 10px);
                padding: 20px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                background-color: #ffffff;
                border: 1px solid var(--color-border);
                cursor: pointer;
                .iconfont {
                    width: 70px;
                    height: 70px;
                    text-align: center;
                    line-height: 70px;
                    font-size: 55px;
                    color: #c6c8d1;
                }
                .text {
                    margin-top: 20px;
                    font-size: 22px;
                    font-family: var(--mg-button-font);
                    color: #515666;
                    line-height: 1.36;
                }
                &:hover {
                    background-color: #fafafd !important;
                }
            }
        }
    }
    @include media-600 {
        .content-box {
            .button-box .button {
                width: calc(50% - 5px);
                .iconfont {
                    width: 40px;
                    height: 40px;
                    line-height: 40px;
                    font-size: 25px;
                }
                .text {
                    margin-top: 5px;
                    font-size: 14px;
                    line-height: 1.43;
                }
            }
        }
    }
}
</style>
